import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _StimulusEdit;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import first from 'lodash/first';
import partial from 'lodash/partial';
import ReactDOM from 'react-dom';
import { Button } from '@instructure/ui-buttons';
import { ToggleDetails } from '@instructure/ui-toggle-details';
import { jsx } from '@instructure/emotion';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import { FILE_UPLOAD_SUCCESS, SHOULD_CLONE_ITEM, DELETED_QUIZ_ENTRY, withStyleOverrides } from '@instructure/quiz-common';
import { propsForStimulusVersioningWrapper, propsForBankEntryVersioningWrapper } from '../../../../util/warningHelpers';
import AddToBankModal from '../../../../../banks/components/AddToBankModal';
import AddToBankOptions from '../../../../../building/components/resources/AddToBankOptions';
import WarningWrapper from '../../WarningWrapper';
import CustomPropTypes from '../../../../../common/util/CustomPropTypes';
import { checkClickedNode } from '../../../../../common/util/clickHandlers';
import StimulusShowInfo from '../StimulusShowInfo';
import StimulusEditInfo from '../StimulusEditInfo';
import wrapWithOutsideClickEmotion from '../../../shared/functionality/componentWithOutsideClickEmotion';
import ActionButtons from '../../../../../building/components/resources/ActionButtons';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
export var StimulusEdit = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_StimulusEdit = /*#__PURE__*/function (_Component) {
  function StimulusEdit() {
    var _this;
    _classCallCheck(this, StimulusEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StimulusEdit, [].concat(args));
    _defineProperty(_this, "state", {
      canSubmit: true
    });
    _defineProperty(_this, "clearModifications", function () {
      _this.props.clearModifications('stimuli', _this.props.stimulus.id);
      _this.props.clearModifications('quizEntries', _this.props.quizEntry.id);
      if (_this.props.stimulus.isTemporary()) {
        _this.props.clearTemporaryStimulus(_this.props.quizId);
      }
    });
    _defineProperty(_this, "onCancel", function (e) {
      _this.props.hideError(_this.props.guid);
      _this.props.switchOffEditing();
      _this.clearModifications();
      _this.props.setUi(SHOULD_CLONE_ITEM, false);
    });
    _defineProperty(_this, "handleDeleteTemporary", function () {
      var isPassage = _this.isPassage();
      _this.props.withConfirm(function () {
        _this.onCancel();
        _this.props.setUi(DELETED_QUIZ_ENTRY, {
          position: Math.ceil(_this.props.quizEntry.position),
          inStimulus: false
        });
      }, {
        title: isPassage ? t('Confirm Passage Removal') : t('Confirm Stimulus Removal'),
        text: isPassage ? t('Are you sure you want to remove this passage?') : t('Are you sure you want to remove this stimulus?'),
        continueText: isPassage ? t('Remove Passage') : t('Remove Stimulus'),
        cancelText: isPassage ? t('Keep Passage ') : t('Keep Stimulus'),
        automationPrefix: isPassage ? 'passage' : 'stimulus'
      });
    });
    _defineProperty(_this, "handleDeleteStimulus", function () {
      if (_this.props.stimulus.isTemporary()) {
        _this.handleDeleteTemporary();
      } else {
        _this.props.openDeleteStimulusModal();
      }
    });
    _defineProperty(_this, "handleStimulusCreated", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(stimulusData) {
        var _this$props, quizId, quizEntry, mods;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, quizId = _this$props.quizId, quizEntry = _this$props.quizEntry;
              mods = Object.assign({}, quizEntry.toJS(), {
                entryId: stimulusData.id,
                entryType: 'Stimulus'
              });
              _context.next = 4;
              return _this.props.updateQuizEntry(quizId, quizEntry.id, mods);
            case 4:
              _this.props.getQuizEntries(quizId);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "createNextQuizEntry", function () {
      var _this$props$nextQuizE = _this.props.nextQuizEntry,
        interactionTypeData = _this$props$nextQuizE.interactionTypeData,
        quizId = _this$props$nextQuizE.quizId,
        position = _this$props$nextQuizE.position,
        stimulusId = _this$props$nextQuizE.stimulusId,
        parentEntryId = _this$props$nextQuizE.parentEntryId;
      if (!interactionTypeData) {
        _this.props.createTempStimulus(quizId, position);
      } else {
        var defaultInteractionData = interactionTypeData.getDefaultInteractionData();
        var scoringData = interactionTypeData.getDefaultScoringData(defaultInteractionData);
        _this.props.createTempItem(quizId, position, {
          id: interactionTypeData.id,
          interactionData: defaultInteractionData,
          itemBody: interactionTypeData.itemBody,
          properties: interactionTypeData.defaultProperties,
          scoringAlgorithm: interactionTypeData.scoringAlgorithmDefault,
          scoringData: scoringData,
          userResponseType: first(interactionTypeData.userResponseTypeOptions)
        }, parentEntryId, stimulusId);
      }
      _this.props.clearNextQuizEntry();
    });
    _defineProperty(_this, "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var _this$props2, stimulus, workingStimulus, quizId, quizEntry, stimulusData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, stimulus = _this$props2.stimulus, workingStimulus = _this$props2.workingStimulus, quizId = _this$props2.quizId, quizEntry = _this$props2.quizEntry;
              if (workingStimulus.isValid()) {
                _context2.next = 8;
                break;
              }
              _context2.next = 4;
              return _this.props.showError(_this.props.guid);
            case 4:
              _this.props.screenreaderNotification(t('Simulus not saved due to validation errors with the data.'));
              _this.props.clearNextQuizEntry();
              _this.focusFirstErrorField();
              return _context2.abrupt("return");
            case 8:
              _this.setState({
                canSubmit: false
              });
              _this.props.hideError(_this.props.guid);
              _context2.prev = 10;
              if (!stimulus.isTemporary()) {
                _context2.next = 17;
                break;
              }
              _context2.next = 14;
              return _this.props.createStimulusAndQuizEntry(quizId, workingStimulus.toJS(), quizEntry);
            case 14:
              _this.props.clearTemporaryStimulus(quizId);
              _context2.next = 28;
              break;
            case 17:
              if (!_this.props.shouldClone) {
                _context2.next = 26;
                break;
              }
              _context2.next = 20;
              return _this.props.createStimulus(workingStimulus, _this.props.quizId, 'quiz', workingStimulus.id);
            case 20:
              stimulusData = _context2.sent;
              _context2.next = 23;
              return _this.handleStimulusCreated(stimulusData);
            case 23:
              _this.props.clearTemporaryStimulus(quizId);
              _context2.next = 28;
              break;
            case 26:
              _context2.next = 28;
              return _this.props.updateStimulus(workingStimulus.toJS(), quizId);
            case 28:
              _context2.next = 34;
              break;
            case 30:
              _context2.prev = 30;
              _context2.t0 = _context2["catch"](10);
              _this.setState({
                canSubmit: true
              });
              throw _context2.t0;
            case 34:
              _this.afterSubmit();
            case 35:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[10, 30]]);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "focusFirstErrorField", function () {
      if (_this.stimulusEditArea) {
        var editArea = ReactDOM.findDOMNode(_this.stimulusEditArea);
        var firstErrorField = editArea === null || editArea === void 0 ? void 0 : editArea.querySelector('[aria-invalid="true"]');
        firstErrorField && firstErrorField.focus();
      }
    });
    _defineProperty(_this, "handleRef", function (node) {
      _this.stimulusEditArea = node;
    });
    _defineProperty(_this, "onSuccess", function (url) {
      _this.props.setUploadStatus(FILE_UPLOAD_SUCCESS);
    });
    _defineProperty(_this, "handleAddToBankContinue", function () {
      _this.setState({
        canSubmit: false
      });
    });
    _defineProperty(_this, "handleAddToBank", function (bankEntry) {
      if (_this.props.workingQuizEntry.isTemporary) {
        _this.props.createQuizEntry(_this.props.quizId, bankEntry.id, 'BankEntry', _this.props.workingQuizEntry.getProperties());
        _this.props.clearTemporaryStimulus(_this.props.quizId);
        _this.clearModifications();
        _this.props.switchOffEditing();
      } else {
        _this.props.updateQuizEntry(_this.props.quizId, _this.props.workingQuizEntry.id, {
          entryId: bankEntry.id,
          entryType: 'BankEntry'
        });
      }
    });
    _defineProperty(_this, "getEntryForBank", function () {
      var _this$props3 = _this.props,
        stimulus = _this$props3.stimulus,
        workingStimulus = _this$props3.workingStimulus,
        quizId = _this$props3.quizId,
        shouldClone = _this$props3.shouldClone;
      if (stimulus.isTemporary()) {
        return _this.props.createStimulus(workingStimulus, quizId);
      } else if (stimulus.hasModifications()) {
        if (shouldClone) {
          return _this.props.createStimulus(workingStimulus, quizId);
        } else {
          return _this.props.updateStimulus(workingStimulus, quizId);
        }
      } else {
        return Promise.resolve(stimulus);
      }
    });
    _defineProperty(_this, "setTitleRef", function (elem) {
      _this.stimulusEditTitleRef = elem;
    });
    return _this;
  }
  _inherits(StimulusEdit, _Component);
  return _createClass(StimulusEdit, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.props.nextQuizEntry) {
        // adding timeout so any content rce events
        // fire before the mods are cleared
        setTimeout(this.clearModifications);
      }
      this.props.switchOffEditing();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.stimulusEditTitleRef && this.stimulusEditTitleRef.focus();
      this.props.switchOnEditing();
      this.props.onEditToggle(this.props.quizEntry.id);
    }
  }, {
    key: "clickedOutside",
    value: function clickedOutside() {
      if (this.props.stimulus.isImmutable() || this.props.isBankedContent) {
        this.props.switchOffEditing();
      } else {
        this.onSubmit();
      }
    }
  }, {
    key: "ignoreClickOutsideIf",
    value: function ignoreClickOutsideIf(e) {
      var _checkClickedNode = checkClickedNode(e, this.props.appContainer),
        isEndEditingTrigger = _checkClickedNode.isEndEditingTrigger,
        outsideApp = _checkClickedNode.outsideApp;
      return outsideApp || !isEndEditingTrigger;
    }
  }, {
    key: "isPassage",
    value: function isPassage() {
      var _this$props$stimulus;
      return (_this$props$stimulus = this.props.stimulus) === null || _this$props$stimulus === void 0 ? void 0 : _this$props$stimulus.passage;
    }
  }, {
    key: "afterSubmit",
    value: function afterSubmit() {
      this.props.switchOffEditing();
      this.clearModifications();
      this.props.setUi(SHOULD_CLONE_ITEM, false);
      this.props.screenreaderNotification(t('Changes to stimulus saved.'));
      if (this.props.nextQuizEntry) {
        this.createNextQuizEntry();
      }
    }
  }, {
    key: "renderAddToBankModal",
    value: function renderAddToBankModal() {
      return jsx(AddToBankModal, {
        label: t('Add to an Item Bank'),
        onAdd: this.handleAddToBank,
        onContinue: this.handleAddToBankContinue,
        getEntry: this.getEntryForBank,
        quizId: this.props.quizId,
        entryId: this.props.guid,
        entryType: this.props.quizEntry.entryType
      });
    }
  }, {
    key: "renderAddToBankOptions",
    value: function renderAddToBankOptions() {
      var paddingTopStyle = this.isPassage() ? {
        padding: 'small 0 0'
      } : {};
      return jsx(View, Object.assign({
        as: "div"
      }, paddingTopStyle), jsx(ToggleDetails, {
        variant: "filled",
        key: "itemBanking",
        summary: t('Item Banking')
      }, jsx("div", {
        css: this.props.styles.optionWrapper
      }, jsx(AddToBankOptions, {
        displayPosition: this.props.displayPosition,
        entryType: this.props.quizEntry.entryType,
        focusFirstErrorField: this.focusFirstErrorField,
        guid: this.props.guid,
        isValid: this.props.workingStimulus.isValid(),
        openModal: this.props.openModal,
        screenreaderNotification: this.props.screenreaderNotification,
        showError: this.props.showError
      }))), this.renderAddToBankModal());
    }
  }, {
    key: "renderStimulusEdit",
    value: function renderStimulusEdit() {
      var stimulusLabel = this.isPassage() ? t('Passage') : t('Stimulus');
      var automationPrefix = this.isPassage() ? 'passage' : 'stimulus';
      return jsx("div", null, jsx("div", {
        css: this.props.styles.stimulus,
        ref: this.handleRef
      }, jsx("div", {
        css: this.props.styles.header
      }, jsx(Text, {
        size: "small",
        color: "secondary"
      }, stimulusLabel), jsx(ActionButtons, {
        connectDragSource: this.props.connectDragSource,
        displayPosition: this.props.displayPosition,
        onDelete: this.handleDeleteStimulus,
        quizEntries: this.props.quizEntries,
        quizEntry: this.props.quizEntry,
        shouldDisableDragHandle: true,
        shouldRenderEdit: false,
        shouldFocusOnMount: this.props.shouldFocusOnMount
      })), jsx("div", {
        css: this.props.styles.stimulusContent
      }, jsx(StimulusEditInfo, {
        errorsShowing: this.props.errorsShowing,
        guid: this.props.guid,
        stimulus: this.props.stimulus,
        isBankedContent: this.props.isBankedContent,
        setTitleRef: this.setTitleRef
      }), this.renderAddToBankOptions())), jsx("div", {
        className: "footer",
        css: this.props.styles.footer
      }, jsx("div", {
        css: this.props.styles.buttonWrapper
      }, jsx(Button, {
        type: "button",
        onClick: this.onCancel,
        "data-automation": "sdk-".concat(automationPrefix, "-discardButton")
      }, t('Cancel'))), jsx("div", {
        className: "submitButtonWrapper",
        css: this.props.styles.buttonWrapper
      }, jsx(Button, {
        type: "button",
        color: "primary",
        disabled: !this.state.canSubmit,
        onClick: this.onSubmit,
        "data-automation": "sdk-".concat(automationPrefix, "-done-button")
      }, t('Done')))));
    }
  }, {
    key: "render",
    value: function render() {
      this.stimulusEditInfoRef = null;
      if (this.props.isBankedContent) {
        return jsx(WarningWrapper, this.props.bankEntryWarningWrapperProps(), jsx(StimulusShowInfo, this.props));
      }
      var _this$props4 = this.props,
        stimulus = _this$props4.stimulus,
        quizEntry = _this$props4.quizEntry;
      var needsWarning = stimulus.isImmutable() || quizEntry.isArchivedBankEntry;
      var propForWrapperFunc = quizEntry.isArchivedBankEntry ? propsForBankEntryVersioningWrapper : propsForStimulusVersioningWrapper;
      var propsForStimulusVersioning = propForWrapperFunc(needsWarning, this.props.shouldClone, partial(this.props.setUi, SHOULD_CLONE_ITEM), this.props.switchOffEditing, true, quizEntry.isArchivedBankEntry ? 'info' : 'warning');
      var hasWarningWrapper = needsWarning && !this.props.shouldClone;
      return jsx(WarningWrapper, propsForStimulusVersioning, hasWarningWrapper ? jsx(StimulusShowInfo, this.props) : this.renderStimulusEdit());
    }
  }]);
}(Component), _defineProperty(_StimulusEdit, "displayName", 'StimulusEdit'), _defineProperty(_StimulusEdit, "componentId", "Quizzes".concat(_StimulusEdit.displayName)), _defineProperty(_StimulusEdit, "propTypes", {
  addContentPopoverOpen: PropTypes.bool.isRequired,
  appContainer: CustomPropTypes.selectors.isRequired,
  bankEntryWarningWrapperProps: PropTypes.func,
  clearModifications: PropTypes.func.isRequired,
  clearNextQuizEntry: PropTypes.func.isRequired,
  createTempItem: PropTypes.func.isRequired,
  createTempStimulus: PropTypes.func.isRequired,
  clearTemporaryStimulus: PropTypes.func.isRequired,
  createQuizEntry: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  createStimulus: PropTypes.func.isRequired,
  createStimulusAndQuizEntry: PropTypes.func.isRequired,
  displayPosition: PropTypes.number.isRequired,
  errorsShowing: PropTypes.bool,
  getQuizEntries: PropTypes.func.isRequired,
  guid: PropTypes.string.isRequired,
  hideError: PropTypes.func.isRequired,
  isBankedContent: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
  openDeleteStimulusModal: PropTypes.func.isRequired,
  nextQuizEntry: ImmutablePropTypes.map,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  quizId: PropTypes.string.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  setUi: PropTypes.func.isRequired,
  setUploadStatus: PropTypes.func.isRequired,
  shouldClone: PropTypes.bool.isRequired,
  showError: PropTypes.func.isRequired,
  stimulus: ImmutablePropTypes.record.isRequired,
  switchOnEditing: PropTypes.func.isRequired,
  switchOffEditing: PropTypes.func.isRequired,
  updateQuizEntry: PropTypes.func.isRequired,
  updateStimulus: PropTypes.func.isRequired,
  withConfirm: PropTypes.func.isRequired,
  workingQuizEntry: ImmutablePropTypes.record.isRequired,
  workingStimulus: ImmutablePropTypes.record.isRequired,
  onEditToggle: PropTypes.func.isRequired,
  shouldFocusOnMount: PropTypes.bool.isRequired,
  styles: PropTypes.object
}), _defineProperty(_StimulusEdit, "defaultProps", {
  bankEntryWarningWrapperProps: function bankEntryWarningWrapperProps() {},
  errorsShowing: false,
  isBankedContent: false,
  nextQuizEntry: null
}), _StimulusEdit)) || _class);
export default wrapWithOutsideClickEmotion(StimulusEdit);